const theme = {
  colors: {
    primary: '#4A6CF7',
    primaryLight: '#6B8AFF',
    primaryDark: '#3451D1',

    success: '#22C55E',
    warning: '#F59E0B',
    danger: '#EF4444',
    info: '#3B82F6',

    text: '#1F2937',
    textSecondary: '#6B7280',
    textLight: '#9CA3AF',

    bg: '#FFFFFF',
    bgWhite: '#FFFFFF',
    bgCard: '#FFFFFF',

    border: '#E5E7EB',
    borderLight: '#F3F4F6',
    borderStrong: 'rgba(0, 0, 0, 0.7)',

    sidebarBg: '#FFFFFF',
    sidebarText: '#1F2937',
    sidebarActive: '#4A6CF7',
    sidebarHover: '#F3F4F6',
  },

  fonts: {
    body: "'Pretendard Variable', Pretendard, -apple-system, BlinkMacSystemFont, system-ui, sans-serif",
  },

  // 글자 크기 시스템
  fontSize: {
    xs: '11px',       // 하단탭 라벨, 캡션
    sm: '13px',       // 보조 텍스트, 날짜, 힌트
    base: '14px',     // 본문, 리스트 항목
    md: '15px',       // 버튼 텍스트
    lg: '16px',       // 섹션 제목
    xl: '18px',       // 페이지 제목, 서브 헤더
    xxl: '22px',      // 이름 (프로필 헤더)
    hero: '36px',     // 큰 금액 표시 (₩0)
  },

  // 글자 굵기 시스템
  fontWeight: {
    regular: 400,     // 본문, 설명
    medium: 500,      // 보조 텍스트
    semibold: 600,    // 버튼, 탭 라벨
    bold: 700,        // 섹션 제목, 페이지 타이틀
    extrabold: 800,   // 큰 금액, 프로필 이름
  },

  // 여백 시스템
  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    base: '16px',
    lg: '20px',       // 페이지 좌우 패딩
    xl: '24px',
    xxl: '32px',      // 섹션 간 간격
    xxxl: '40px',
  },

  radius: {
    sm: '6px',
    md: '10px',
    lg: '16px',
    pill: '8px',      // 버튼 기본 radius
    full: '9999px',   // 원형 (아바타)
  },

  shadow: {
    sm: '0 1px 2px rgba(0,0,0,0.05)',
    md: '0 4px 6px -1px rgba(0,0,0,0.07), 0 2px 4px -1px rgba(0,0,0,0.04)',
    lg: '0 10px 15px -3px rgba(0,0,0,0.08), 0 4px 6px -2px rgba(0,0,0,0.03)',
  },

  breakpoints: {
    mobile: '768px',
    // 부동산 전용 — 폴드 펼친 가로(~1104px)까지 모바일 레이아웃 유지
    // min-width 짝은 1281px 사용 (CSS 미디어쿼리에서 calc 불가)
    realtorMobile: '1280px',
  },

  // Realtor(부동산) 전용 토큰
  realtor: {
    headerBg: '#EDF2F7',           // 프로필 헤더 배경
    avatarBg: '#4A6CF7',           // 아바타 배경 (파란색)
    avatarText: '#FFFFFF',         // 아바타 글자
    avatarSize: '56px',            // 아바타 크기
    sectionBarColor: '#4A6CF7',    // 섹션 제목 앞 세로바
    sectionBarWidth: '3px',        // 세로바 두께
    sectionBarHeight: '18px',      // 세로바 높이
    pagePadding: '20px',           // 페이지 좌우 패딩
    sectionGap: '32px',            // 섹션 간 간격
    bottomNavHeight: '60px',       // 하단탭 높이
    contentMaxWidth: '480px',      // 모바일 프레임 최대 너비
    emptyIconColor: '#D1D5DB',     // 빈 상태 아이콘 색상
    linkColor: '#6B7280',          // 링크 텍스트 (예: "또는 QR코드로...")
  },
};

export default theme;
